<div>
  <ng-template *ngIf="fromDataView" ngFor let-info [ngForOf]="templateRecordInfo" [ngForTrackBy]="trackByModel">
    <lm-template-form-record
      [@questionVisibility]="info.isQuestionVisible ? 'visible' : 'hidden'"
      [info]="info"
      [formUrlInfo]="formUrlInfo"
      [formSpec]="formSpec"
      [formOptions]="formOptions"
      [specFields]="specFields"
      [layout]="layout"
      [model]="info.model"
      (fieldEvent)="onFieldEvent($event)"
    >
    </lm-template-form-record>
  </ng-template>
  <div *ngIf="showEmptyMessage" soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
</div>

<div #dialogPlaceholder id="lmFormContentTemplateDialogPlaceholder" class="lmDialogPlaceholder"></div>
